import { Serializable } from "../utilities/Serializable";
import { CardType } from "./CardType";
import { CardTransaction } from "./CardTransaction";
import { Utils } from '../../providers/paytron-backend/utils';
import { CardStatus } from "./CardStatus";

export class Card extends Serializable {
    uuid: string;
    name: string;
    activationDate: string;
    expirationDate: string;
    status: CardStatus;
    balance: number;
    balanceVersion: number;
    initialAmount: number;
    initialRecharge: CardTransaction;
    plafond: number;
    posUuid: string;
    notes: string;
    type: CardType;
    blacklisted: boolean;
    currentAccountUuid: string;
    secondCircuitUuid: string;
    secondCircuitPlafond: Number;
    securityDeposits: CardTransaction[];
    missingTransactions: boolean;
    roomNumber: string;
    cloned: boolean;

    constructor() {
        super();
        this.activationDate = new Utils("en-US", null).toInputDateString(Date.now());
        this.status = CardStatus.Active;
        this.notes = null;
        this.balance = 0;
        this.balanceVersion = 0;
        this.initialAmount = 0;
        this.type = new CardType();
        this.blacklisted = false;
        this.roomNumber = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Card.ts